<ng-container *ngIf="comment$ | async; let comment">
  <div class="blue-border"></div>
  <loop-mail-comment-header
    [isCommentCollapsed]="isCollapsed"
    [comment]="comment"
    [conversation]="conversation"
    [areActionsVisible]="!isCompactSignal()"
    (popOut)="handlePopOut(comment)"
    (collapse)="toggleCollapse()"
    (openQuickReply)="handleOpenQuickReply(comment)"
    (closeQuickReply)="closeQuickReply.emit()"
    (commentMailTranslate)="handleCommentMailTranslate($event)"
  >
  </loop-mail-comment-header>

  <ng-container *ngIf="translatedCommentResponse$ | async; let translatedCommentResponse">
    <loop-change-translations-language
      *ngIf="!isCollapsed"
      [fromLanguage]="translatedCommentResponse.response.from_language"
      [toLanguage]="translatedCommentResponse.response.to_language"
      [isOriginal]="translatedCommentResponse.isOriginal"
      (translationsOptionsChange)="handleLanguageChange($event)"
      class="flex padding-horizontal"
    ></loop-change-translations-language>
  </ng-container>

  <div
    *ngIf="!isCollapsed"
    class="flex flex-1 flex-col padding-horizontal overflow-auto-y"
    [class.attachments-top]="(attachmentPosition$ | async) === 'top'"
    [class.attachments-bottom]="(attachmentPosition$ | async) === 'bottom'"
  >
    <ng-container *ngIf="(attachmentPosition$ | async) === 'top'">
      <ng-container *ngTemplateOutlet="attachmentsTpl"></ng-container>
    </ng-container>

    <shadowed-content
      *ngIf="commentHtml$ | async; let commentHtml"
      [whiteSpacePre]="!comment.body"
      [innerHTML]="commentHtml | autolink | safe"
      [snippet]="comment.snippet && comment.snippet.length === 256 ? comment.snippet + '...' : comment.snippet"
      [shouldAppendCollapse]="shouldAppendCollapse"
      [handleInlineImageClickFn]="comment | inlineImageClickHandlerFn"
      (inlineImagesLoaded$)="commentFullyLoaded()"
    >
    </shadowed-content>

    <ng-container *ngIf="(attachmentPosition$ | async) === 'bottom'">
      <ng-container *ngTemplateOutlet="attachmentsTpl"></ng-container>
    </ng-container>

    <ng-template #attachmentsTpl>
      <attachments
        *ngIf="conversation && (comment.attachments?.resources || []).length"
        [attachments]="comment.attachments?.resources || []"
        [conversationName]="conversation.name"
        [arePreviewsEnabled]="areAttachmentsPreviewsShown$ | async"
        [canDownloadAll]="true"
      >
      </attachments>
    </ng-template>
  </div>

  <div
    *ngIf="
      !isCompactSignal() &&
      !isCollapsed &&
      conversation.channelType !== ChannelType_LoopSpam &&
      (fromOptionsCount$ | async)
    "
  >
    <div class="flex actions padding-horizontal padding-vertical-quarter justify-between">
      <ng-container *ngIf="isClosed; else replyOptionsTpl">
        <div class="flex flex-1 justify-end font-new-default text-medium">Conversation closed</div>
      </ng-container>
      <ng-template #replyOptionsTpl>
        <div class="flex gap-half">
          @if (comment.isLastMailComment && !isExternalWindow) {
            <div
              class="clickable-icon flex gap-half items-center"
              [loopHoverTooltip]="'Quick reply (A)'"
              (click)="handleOpenQuickReply(comment)"
            >
              <loop-icon name="reply-all" width="20px" height="20px"></loop-icon>
              <div class="font-new-default font-bold">Quick reply</div>
            </div>
          }
        </div>
        <div class="flex gap-half">
          @if (isAIEnabledSignal()) {
            <div *browserExternalWindowHidden>
              <div
                #dropdownContainerTpl
                class="clickable-icon ai-actions"
                [loopHoverTooltip]="'Assist me'"
                (click)="openOpenAiDropdownOptions(comment)"
              >
                <loop-icon name="microchip-ai" width="20px" height="20px"></loop-icon>
              </div>
            </div>
          }
          <div class="clickable-icon" [loopHoverTooltip]="'Reply all (Shift+A)'" (click)="replyAll(comment)">
            <loop-icon name="reply-all" width="20px" height="20px"></loop-icon>
          </div>
          <div class="clickable-icon" [loopHoverTooltip]="'Reply (R)'" (click)="reply(comment)">
            <loop-icon name="reply" width="20px" height="20px"></loop-icon>
          </div>
          <div [loopHoverTooltip]="'Forward (F)'" class="clickable-icon" (click)="forward(comment)">
            <loop-icon name="forward" width="20px" height="20px"></loop-icon>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>
